import {
  DELETE_TRANSPORTCOMPANIES_CATALOG,
  DELETE_TRANSPORTCOMPANIES_CATALOG_SUCCESS,
  DELETE_TRANSPORTCOMPANIES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteTransportCompaniesCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case DELETE_TRANSPORTCOMPANIES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_TRANSPORTCOMPANIES_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_TRANSPORTCOMPANIES_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
